 import  { SNSClient } from "@aws-sdk/client-sns";
 // Set the AWS Region.
 const REGION = "us-west-2"; //e.g. "us-east-1"
 // Create SNS service object.
 const credentials = {
     accessKeyId: "AKIAWNMTBT6IV763TDPE",
     secretAccessKey: "08dUrgxVzdZizcHJKogocQGoP/bQ/lSAQph5mLWU"
 }
 const snsClient = new SNSClient({ region: REGION, credentials:credentials });
 export  { snsClient };